import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const normaInMetalandQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist-added",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/norma-in-metaland/NormaInMetalandTrailer.mp4`,
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-trailer-watched",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join GRAM Community on Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/gramecosystem",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-discord",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @gram_voyage on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/gram_voyage",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-1",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow @norma_metaland on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/norma_metaland",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2-followed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-twitter-2",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-onboarding-completed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-onboarding",
  },
];

const normaInMetalandQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Norma in Metaland",
    caption: "Extra Gems daily for sharing on X",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon>",
    eventId: "0c941516-d4df-4adf-aa42-fe601ee852cf-recurring-tweet-completed",
    ruleId: "0c941516-d4df-4adf-aa42-fe601ee852cf-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@norma_metaland",
    recurring: true,
    tweetUsername: "@norma_metaland",
  },
];

export const normaInMetalandQuests: QuestGroup[] = [
  {
    key: "level-0",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +50 <icon> Gems",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/",
      title: "Thanks for getting involved",
      label: "Discover new games you can support",
      caption: "Do quests & earn rewards",
    },
    totalGemsGranted: 50,
    quests: normaInMetalandQuestsList,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems daily by posting to socials",
    },
    totalGemsGranted: 10,
    quests: normaInMetalandQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
